import React from 'react';

import Spinner from '@atlaskit/spinner';

const CenteredSpinner = (props) => <div style={{ display: 'flex', justifyContent: 'center' }}><Spinner {...props}/></div>;
export default CenteredSpinner;
